import React, { Component, Fragment } from 'react'
import { Accordion } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import WidgetComponent from "../../components/Widget";
import CoverDetails from "../../components/CoverDetailsModal";
import CheckBoxInsurance from "../../components/CheckBoxInsurance";

import DataService from "../../service/data";

import TaContext from './TaContext';
import { TYPE_CODES } from "../../const";


class Step2 extends Component {
  state = {
    selected: "",
    coverDetails: [],
  };

  async initCoverDetail(productCode, selectedPackage, custOrder) {

    try {
      const callers = [];
      callers.push(
        DataService.getCoverDetails({
          product_code: productCode,
          package_code: selectedPackage,
          cust_order: custOrder,
        })
      );
      const responses = await Promise.all(callers);
      this.setState({
        ...this.state,
        coverDetails: responses[0],
      });
    } catch (err) {
      console.log(err);
    }
  }
  
  showModal = () => {
    const { step1, counter } = this.context;
    const { selectedPlan } = this.context;
    const { coverDetails } = this.state;

    this.setState({ show: true }, () => {
      if (coverDetails.length === 0) {
        setTimeout(() => {
          this.initCoverDetail(TYPE_CODES.TAPS, selectedPlan, counter);
        }, 1000);
      }
    });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  async initCoverDetail(productCode, selectedPackage, custOrder) {
    try {
      const callers = [];

      callers.push(
        DataService.getCoverDetails({
          product_code: productCode,
          package_code: selectedPackage,
          cust_order: custOrder,
        })
      );

      const responses = await Promise.all(callers);

      this.setState({
        ...this.state,
        coverDetails: responses[0],
      });
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { step2, diffDate = 2, counter } = this.context;
    const {
      planList = [],
      selectedPlan,
      acceptInsurance,
      acceptHealthCheck,
      onChangeModel,
    } = step2;
    const { show, coverDetails } = this.state;
    return (
        <div className="form-wrapper">
        <Accordion
          className="accordion-widget-wrapper"
          defaultActiveKey={selectedPlan}
        >
          {planList.map((item, index) => {
            return (
              <Fragment key={index}>
                <WidgetComponent
                  diffDate={diffDate}
                  counter={counter}
                  key={index}
                  listItem={item}
                  showModal={this.showModal}
                  selected={selectedPlan}
                  onChangePlan={(selected) =>
                    onChangeModel({ name: "selectedPlan", value: selected })
                  }
                />
              </Fragment>
            );
          })}

          <CoverDetails
            show={show}
            hideModal={this.hideModal}
            listItem={planList} //item
            insurance_type={"ประกันการเดินทางภายในประเทศ"}
            productCode={TYPE_CODES.TAPS}
            selectedPackage={selectedPlan}
            custOrder={"1"}
            coverDetails={coverDetails}
            onChangeMedical={this.onChangeMedical}
          />
        </Accordion>
        <CheckBoxInsurance
          checked={acceptInsurance}
          checked3={acceptHealthCheck}
          onCheckChange={(name, checked) =>
            onChangeModel({ name: name, value: checked })
          }
        />
      </div>
    )
  }
}


Step2.contextType = TaContext;
export default withRouter(Step2);
